import request from '@/utils/request'

export function updateProbCfg(data) {
  return request({
    url: 'api/v1/pig/updateProbCfg',
    method: 'post',
    data: data
  })
}
export function updateBasicCfg(data) {
  return request({
    url: 'api/v1/pig/updateBasicCfg',
    method: 'post',
    data: data
  })
}

export function getProbCfgList(data) {
  return request({
    url: 'api/v1/pig/getProbCfg',
    method: 'post',
    data: data
  })
}

export function getBasicCfgList(data) {
  return request({
    url: 'api/v1/pig/getBasicCfg',
    method: 'post',
    data: data
  })
}

export function exportProb(data) {
  return request({
    url: 'api/v1/pig/exportProb',
    method: 'post',
    data: data
  })
}

export function exportBasic(data) {
  return request({
    url: 'api/v1/pig/exportBasic',
    method: 'post',
    data: data
  })
}

export function importProb(data) {
  return request({
    url: 'api/v1/pig/importProb',
    method: 'post',
    data: data
  })
}

export function importBasic(data) {
  return request({
    url: 'api/v1/pig/importBasic',
    method: 'post',
    data: data
  })
}
export function delPigProb(data) {
  return request({
    url: 'api/v1/pig/deleteProb',
    method: 'delete',
    data: data
  })
}

export function delPigBasic(data) {
  return request({
    url: 'api/v1/pig/deleteBasic',
    method: 'delete',
    data: data
  })
}
